import React from "react";
import {
    List,
    Datagrid,
    Edit,
    Create,
    TextField,
    EditButton,
    TextInput,
    Filter,
} from "react-admin";
import BaseForm from "../baseForm";

const form = <BaseForm fields={
    {name: '', name_vi: '', price: 0, duration_of_month: 0, order: 0}
} editors={
    {description: '', description_vi: ''}
} checkboxes={
    {is_permanently: false, is_highlight: false}
}/>

const InnerSoundPackageFilter = (props) => (
    <Filter {...props}>
        <TextInput source="name" label="Name" alwaysOn/>
    </Filter>
);

export const InnerSoundPackageList = props => (
    <List {...props} filters={<InnerSoundPackageFilter/>} filter={{is_published: true}}>
        <Datagrid>
            <TextField source="id"/>
            <TextField source="name"/>
            <TextField source="name_vi"/>
            <TextField source="order"/>
            <TextField source="price"/>
            <TextField source="duration_of_month"/>
            <EditButton basePath="/inner-sound-package"/>
        </Datagrid>
    </List>
);

export const InnerSoundPackageEdit = props => (
    <Edit title='Update' {...props}>
        {form}
    </Edit>
);

export const InnerSoundPackageCreate = props => (
    <Create title="Create" {...props}>
        {form}
    </Create>
);
